export default __webpack_public_path__ + "pencilfish_camera.14fbbc6f.png";